
<template>
    <div class="list-row-container" :class="{ 'is-processed' : deviation.is_processed, 'deviation-deleted' : deviation.deleted_at }">
        <div class="row py-1">
            <div class="col d-none d-md-flex col-md-1 align-items-start">
                <span>{{ deviation.id }}</span>
            </div>

            <div class="col d-none d-md-flex col-md-2 align-items-start">
                <div class="tooltip-target h-100">
                    <span>{{ formatDate(deviation.created_at) }}</span>
                    <div class="tooltip-label">
                        {{ deviation.created_at }}
                    </div>
                </div>
            </div>

            <div class="col d-none d-md-flex col-md-3 align-items-start">

                <a :href="'/customers/'+deviation.customer.id" target="_blank" v-if="deviation.customer">{{ deviation.customer.name }}</a>
                <div v-else>
                    <div v-if="deviation.customer_name"><b>{{ deviation.customer_name }}</b></div>
                    <div v-if="deviation.customer_phone"><span class="wrap-text">{{ deviation.customer_phone }}</span></div>
                    <div v-if="deviation.customer_email"><span class="wrap-text">{{ deviation.customer_email }}</span></div>
                </div>

            </div>

            <div class="col d-none d-md-flex col-md-3 d-block align-items-start">

                <div>
                    <a :href="'/clinics/'+deviation.clinic.id" target="_blank" v-if="deviation.clinic">{{ deviation.clinic.name_person }}</a><br>
                    <span>{{ deviation.signature_key }}</span>
                </div>

            </div>

            <div class="col d-none d-md-flex col-md-2 align-items-start">
                <div>
                    <span>{{ deviation.treatment_date }}</span><br>
                    <span v-if="deviation.duration">{{ deviation.duration.minutes }} min</span>
                </div>
            </div>

            <div class="col d-none d-md-block col-md-4 align-items-start">
                <b>{{ deviation.reasonNice }}</b>
                <div><span>{{ deviation.reason_description }}</span></div>
            </div>

            <div class="col d-none d-md-flex col-md-4 align-items-start">
                <textarea rows="7" class="form-control deviation-comment" v-model="comment"></textarea>
            </div>

            <div class="col d-none d-md-flex col-md-4 align-items-start justify-content-end">
                <button class="btn btn-primary btn-sm mb-2" @click="autoSolve()"  v-if="deviation.showAutoButton && deviation.is_processed != 1">
                    <div class="spinner-border spinner-border-sm d-inline-block" style="margin-right:6px;" v-if="auto_loading == deviation.id"></div>
                    <img src="/images/admin/icon-auto.svg" v-else>
                    <span>Registrera</span>
                </button>
                <button class="btn btn-secondary btn-sm ms-4" @click="manualSolve()" v-if="!deviation.is_processed && !deviation.deleted_at"><img src="/images/admin/icon-new-window.svg" style="margin-top:3px;">Öppna</button>
            </div>

            <div class="col d-none d-md-flex col-md-1 align-items-start">
                <img src="/images/admin/icon-check.svg" v-if="deviation.is_processed">
                <button class="btn btn-secondary btn-sm" @click="process()" v-else>Klar</button>
            </div>

        </div>
    </div>
</template>

<script>

import axios from 'axios'
import Cookies from 'js-cookie'

export default {
    props: {
        deviation: {
            required: true
        }
    },

    data () {
        return {
            comment: this.deviation.comment,
            auto_loading: ''
        }
    },

    watch: {
        comment () {
            this.saveComment()
        }
    },

    methods: {
        saveComment () {
            axios.post('/deviations/saveComment', {
                deviation_id: this.deviation.id,
                comment: this.comment
            }).catch(() => {
                alert('Kunde inte spara kommentar, vänligen försök igen.')
            })
        },
        process () {
            axios.post('/deviations/process', {
                deviation_id: this.deviation.id
            }).then((response) => {
                this.$emit('refresh')
            }).catch(() => {
                alert('Kunde inte klarmarkera, vänligen försök igen.')
            })

            Cookies.remove('manualDeviation')
            jQuery('#manualDeviationWindow').hide()
        },
        autoSolve () {
            this.auto_loading = this.deviation.id

            axios.post('/deviations/autoSolve', {
                deviation_id: this.deviation.id
            }).then((response) => {
                this.$emit('refresh')
                this.auto_loading = ''

                let notifyMessage = 'Klippet har registrerats i kundens klippkort.'
                if (this.deviation.reason == 'no_show' || this.deviation.reason == 'no_app' || this.deviation.reason == 'late_cancelling') {
                    notifyMessage = 'Klippet har registrerats i kundens klippkort och mejl har skickats till kunden.'
                }

                bus.$emit(
                    'notify',
                    notifyMessage
                )
            }).catch((error) => {
                this.auto_loading = ''

                if (error.response.status === 403) {
                    alert('Behandlingen kunde inte registreras. Du kan bara registrera 2 behandlingar per vecka och klippkort automatiskt. Gör registreringen manuellt istället.')
                } else {
                    alert('Kunde inte automatiskt hantera, vänligen försök igen.')
                }
            })
        },
        manualSolve () {
            const inFifteenMinutes = new Date(new Date().getTime() + 10 * 60 * 1000)

            const manualDeviation = [this.deviation.id, this.deviation.customer_name, this.deviation.customer_phone, this.deviation.treatment_date, this.deviation.duration.minutes, this.deviation.signature_key, this.deviation.clinic.name_person, this.deviation.reasonNice, this.deviation.reason_description, this.deviation.customer_email]

            const json_manualDeviation = JSON.stringify(manualDeviation)

            Cookies.set('manualDeviation', json_manualDeviation, { expires: inFifteenMinutes })

            if (this.deviation.customer) {
                window.open('/customers/' + this.deviation.customer.id)
            } else {
                window.open('/customers/')
            }
        },
        formatDate (date) {
            return date.substr(0, 10)
        }
    }
}
</script>
